<div style="position: relative; height: 100%">
  <h4 style="display: flex;flex-direction: row;" mat-dialog-title>
    <span></span>
    <button mat-icon-button mat-dialog-close style="position:absolute;right:0;top:0;z-index: 1000"  (click)="dialogRef.close()">
      <mat-icon>close</mat-icon>
    </button>
  </h4>
  <div mat-dialog-content class="center-text">
    <div class="title-green" style="text-align: center">
      Bravo, vous êtes bien assuré. C'est peut-être le moment de vérifier vos montants de prise en charge ?
    </div>
    <div class="title-green" style="margin-top: 20px;">
      Contactez un conseiller Groupama pour faire le point.
    </div>
  </div>
</div>

